import { DEFAULT_INCLUDED_TYPES } from "@/types/domain";

const ALLOWED_TYPES = new Set<string>(DEFAULT_INCLUDED_TYPES);

export function isRelevantType(primaryType: string | null): boolean {
  if (primaryType == null) return true;
  return ALLOWED_TYPES.has(primaryType);
}
